import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'

import type { IChatbotConversationResponse, IParamsUnenrollContact } from './conversationTypes'

class Api {
  start(id: number): Promise<AxiosResponse<IChatbotConversationResponse>> {
    return baseApi.post(`chatbot/api/chatbots/conversation/start/${id}/0`)
  }

  message(uuid: string, message: string): Promise<AxiosResponse<IChatbotConversationResponse>> {
    return baseApi.post(`chatbot/api/chatbots/conversation/message/${uuid}`, {
      message: message,
      core_message_id: 0,
    })
  }

  autoStart(uuid: string): Promise<AxiosResponse<IChatbotConversationResponse>> {
    return baseApi.post(`chatbot/api/chatbots/conversation/auto-start-message/${uuid}`)
  }

  getHistory(uuid: string): Promise<AxiosResponse<IChatbotConversationResponse>> {
    return baseApi.get(`chatbot/api/chatbots/conversation/history/${uuid}`)
  }

  testFollowup(uuid: string): Promise<AxiosResponse<IChatbotConversationResponse>> {
    return baseApi.post(`chatbot/api/chatbots/conversation/followup/${uuid}`)
  }

  unenrollContact(params: IParamsUnenrollContact): Promise<void> {
    return baseApi.put('conversations/bulk-claim', params)
  }
}

export const ChatbotConversationApi = new Api()
